<template>
  <div class="container">
    <Modal v-model="delReceiveModel" title="删除回款记录" @on-ok="delReceive">
      <p>你确定要删除此条回款记录吗？</p>
    </Modal>
    <Modal v-model="invalidReceiveModel" :title="invalid ? '恢复此条回款记录' : '作废此条回款记录'" @on-ok="invalidReceiveMethod">
      <p>确认是否{{ invalid ? "恢复" : "作废" }}此条回款记录吗？</p>
    </Modal>
    <Modal v-model="exportReceiveModal" title="筛选导出数据" class="select-export-receive" @on-visible-change="exportReceiveModalClose">
      <Form ref="exportItem" :model="exportItem" :rules="ruleValidate" label-position="top">
        <FormItem label="开始月份" prop="startMonth" class="export-item">
          <DatePicker type="month" @on-change="changeDate('start')" v-model="exportItem.startMonth" placeholder="选择开始月份"></DatePicker>
          <div class="dateStr">开始日期：{{ startMonthStr }}</div>
        </FormItem>
        <FormItem label="结束月份" prop="endMonth" class="export-item">
          <DatePicker type="month" @on-change="changeDate('end')" v-model="exportItem.endMonth" placeholder="选择结束月份"></DatePicker>
          <div class="dateStr">结束日期：{{ endMonthStr }}</div>
        </FormItem>
        <FormItem label="公司数量" prop="manyCompany" class="export-item">
          <RadioGroup v-model="manyCompany">
            <Radio label="all" :disabled="
                !(
                  currentUser.superAdmin ||
                  arrayIntersection(
                    ['salesLead', 'acctManager'],
                    currentUser.simpleRole
                  ).length > 0
                )
              ">
              <span>全部公司</span>
            </Radio>
            <Radio label="one">
              <span>一个公司</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="筛选公司" prop="company" class="export-item" v-if="manyCompany === 'one'">
          <Select placeholder="筛选公司" v-model="exportItem.company" label-in-value clearable style="width: 220px; margin-right: 30px">
            <Option v-for="item in companyList" :value="item._id" :key="item._id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="exportReceive('exportItem')">导出</Button>
      </template>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input v-model="searchText" search placeholder="搜索客户..." @on-change="searchCustomer" clearable icon="ios-search" style="width: 230px; margin-right: 20px">
        </Input>
        <Select placeholder="筛选公司" v-model="company" label-in-value clearable @on-change="choseCompany" style="width: 180px; margin-right: 30px">
          <Option v-for="item in companyList" :value="item._id" :key="item._id">{{ item.name }}</Option>
        </Select>
        <Select placeholder="筛选类型" v-model="selectType" label-in-value clearable @on-change="choseType" style="width: 120px; margin-right: 30px">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Select placeholder="筛选状态" v-model="selectStatus" label-in-value clearable @on-change="choseStatus" style="width: 120px; margin-right: 30px">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Select placeholder="筛选回款人" v-model="selectReceivedBy" label-in-value clearable filterable @on-change="choseReceivedBy" style="width: 120px; margin-right: 30px">
          <Option v-for="item in simpleUserList" :value="item._id" :key="item._id">{{ item.name }}</Option>
        </Select>
        <Checkbox v-model="isInvalid" @on-change="changeIsInvalid">查看作废</Checkbox>
        <div class="refresh" @click="refreshMethod">
          <Icon type="ios-refresh" size="24" />
        </div>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page :total="totalRows" :page-size="20" @on-change="loadReceive" show-total simple style="margin-right: 24px" />
        </div>
        <Button type="success" style="margin-right: 20px" :loading="exportReceiveLoading" @click="openExportReceiveModal()">导出数据</Button>
        <Button type="primary" @click="openEditReceiveDrawer()">创建记录</Button>
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="receiveList" :height="tableHeight" :loading="tableLoading" @on-row-click="openEditReceive">
        <template slot-scope="{ row }" slot="operate">
          <div style="
              display: flex;
              justify-content: space-around;
              align-items: center;
            ">
            <Button v-if="row.status === 'needConfirm'" type="default" size="small" @click="$refs.EditReceiveDrawer.openDrawer(row, 'verify')">审核</Button>
            <Dropdown trigger="hover" @on-click="clickActionDropDown" transfer>
              <a>
                更多
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <div>
                  <DropdownItem :name="`I ${row._id}`" style="color: #ed4014">{{
                    row.invalid ? "恢复" : "作废"
                  }}</DropdownItem>
                  <DropdownItem v-if="currentUser.superAdmin" :name="`D ${row._id}`" style="color: #ed4014">删除</DropdownItem>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </Table>
    </div>
    <EditReceiveDrawer ref="EditReceiveDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import EditReceiveDrawer from "./EditReceiveDrawer.vue";
import axios from "@/utils/axios";
import { fromModelToText, typeToText, statusToText, billStatusToText, billTagsToText } from '@/utils/index'
import dayjs from "dayjs";
import _ from "lodash";

export default {
  name: "Receive",
  components: { EditReceiveDrawer },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      tableLoading: false,
      selectReceivedBy: null,
      volIndexFile: null,
      volFile: null,
      editVol: null,
      limit: 20,
      page: 0,
      filterQuery: {},
      isInvalid: false,
      columns: [
        {
          title: "收到日期",
          key: "receivedAt",
          minWidth: 90,
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h("span", dayjs(params.row.receivedAt).format("YYYY-M-D")),
            ]);
          },
        },
        {
          title: "项目",
          key: "receiveItem",
          fixed: "left",
          minWidth: 90,
          align: "left",
          render: (h, params) =>
            h("span", fromModelToText[params.row.receiveItem]),
        },
        {
          title: "付款对象",
          key: "from",
          fixed: "left",
          minWidth: 190,
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  cursor: "pointer",
                  color: "#42b983",
                },
                on: {
                  click: () => {
                    this.$refs.EditReceiveDrawer.openDrawer(params.row);
                  },
                },
              },
              params.row.from ? params.row.from.name : ""
            ),
        },
        {
          title: "内容",
          key: "content",
          fixed: "left",
          minWidth: 150,
          align: "left",
          render: (h, params) => h("span", params.row.content),
        },

        {
          title: "提交金额",
          key: "submitAmount",
          minWidth: 100,
          align: "right",

          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  color: "#a1a3a6",
                },
              },
              params.row.submitAmount
                ? params.row.submitAmount.toLocaleString()
                : ""
            ),
        },
        {
          title: "实际金额",
          key: "amount",
          minWidth: 100,
          align: "right",
          render: (h, params) =>
            h(
              "span",
              params.row.amount ? params.row.amount.toLocaleString() : ""
            ),
        },
        {
          title: "收款公司",
          key: "company",
          minWidth: 120,
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.company.abbr
                ? params.row.company.abbr
                : params.row.company.name
            ),
        },
        {
          title: "收款账号",
          key: "bankAccount",
          minWidth: 100,
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.bankAccount ? params.row.bankAccount.abbr : ""
            ),
        },
        {
          title: "类型",
          key: "type",
          minWidth: 100,
          align: "center",
          render: (h, params) => h("span", typeToText[params.row.type]),
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 150,
          align: "left",
          render: (h, params) => h("span", params.row.remark),
        },
        {
          title: "审核状态",
          minWidth: 110,
          key: "status",
          align: "center",
          fixed: "right",
          render: (h, params) => h("span", statusToText[params.row.status]),
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          align: "center",
          fixed: "right",
          width: 150,
        },
        {
          title: "收款人",
          minWidth: 100,
          key: "receivedBy",
          align: "center",
          render: (h, params) =>
            h("span", params.row.receivedBy ? params.row.receivedBy.name : ""),
        },
        {
          title: "创建人",
          minWidth: 100,
          key: "createdBy",
          align: "center",
          render: (h, params) =>
            h("span", params.row.createdBy ? params.row.createdBy.name : ""),
        },
        {
          title: "创建时间",
          minWidth: 110,
          key: "createdAt",
          align: "left",
          render: (h, params) =>
            h("span", dayjs(params.row.createdAt).format("YYYY-MM-DD")),
        },
        {
          title: "汇票编号",
          minWidth: 160,
          key: "billNo",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.bill?.billNo
            ),
        },
        {
          title: "出票公司",
          minWidth: 160,
          key: "billCompany",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.bill?.billCompany
            ),
        },
        {
          title: "出票银行",
          minWidth: 160,
          key: "billBank",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                },
              },
              params.row.bill?.billBank
            ),
        },
        {
          title: "出票日期",
          minWidth: 110,
          key: "billIssuedAt",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.bill
                ? dayjs(params.row.bill.billIssuedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
        {
          title: "汇票到期",
          minWidth: 110,
          key: "billEndedAt",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.bill
                ? dayjs(params.row.bill.billEndedAt).format("YYYY-MM-DD")
                : ""
            ),
        },
        {
          title: "汇票状态",
          minWidth: 110,
          key: "billStatus",
          align: "center",
          render: (h, params) =>
            h("span", billStatusToText[params.row.bill?.billStatus]),
        },
        {
          title: "汇票标签",
          minWidth: 110,
          key: "tags",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.bill
                ? params.row.bill.tags.map((x) => billTagsToText[x]).join(",")
                : ""
            ),
        },
        {
          title: "是否锁定",
          minWidth: 100,
          key: "isLocked",
          align: "center",
          render: (h, params) => h("span", params.row.isLocked ? "锁定" : ""),
        },
      ],
      typeList: [
        {
          value: "trans",
          label: "银行转账",
        },
        {
          value: "bankAccBill",
          label: "银承",
        },
        {
          value: "commAccBill",
          label: "商承",
        },
        {
          value: "check",
          label: "支票",
        },
        {
          value: "cash",
          label: "现金钞票",
        },
        {
          value: "yun",
          label: "云信通",
        },
        {
          value: "jian",
          label: "建信融通",
        },
        {
          value: "bankAccBillPaper",
          label: "纸质银承",
        },
        {
          value: "gold",
          label: "金单",
        },
        {
          value: "sywx",
          label: "商银微芯",
        },
        {
          value: "ji",
          label: "集信",
        },
        {
          value: "zhu",
          label: "筑信",
        },
      ],
      statusList: [
        {
          value: "needConfirm",
          label: "需财务确认",
        },
        {
          value: "confirmed",
          label: "已确认",
        },
        {
          value: "rejected",
          label: "财务拒绝",
        },
        {
          value: "cancelled",
          label: "业务员取消",
        },
      ],
      delReceiveModel: false,
      invalidReceiveModel: false,
      invalid: null,
      actionReceiveId: null,
      company: null,
      selectType: null,
      selectStatus: null,
      exportReceiveLoading: false,
      exportReceiveModal: false,
      exportItem: {
        startMonth: null,
        endMonth: null,
        company: null,
      },
      startMonthStr: null,
      endMonthStr: null,
      manyCompany: "one",
      ruleValidate: {
        company: [
          { required: true, message: "公司为必填项", trigger: "submit" },
        ],
        startMonth: [
          { required: true, message: "开始月份为必填项", trigger: "submit" },
        ],
        endMonth: [
          { required: true, message: "结束月份为必填项", trigger: "submit" },
        ],
      },
    };
  },
  sockets: {
    async connect() {
      console.log("connect success");
    },
  },
  computed: mapState({
    receiveList: (state) => state.receive.receiveList,
    totalRows: (state) => state.receive.totalCounts,
    currentUser: (state) => state.auth.currentUser,
    companyList: (state) => state.company.companyList,
    user: (state) => state.auth.currentUser,
    customerId: (state) => state.customer.detailCustomersId,
    simpleUserList: (state) => state.user.simpleUserList,
  }),
  methods: {
    ...mapActions({
      getReceive: "receive/getReceiveAction",
      deleteReceive: "receive/deleteReceiveAction",
      invalidReceive: "receive/invalidReceiveAction",
      getReceiveById: "receive/getReceiveByIdAction",
      getCompanyList: "company/getCompanyListAction",
      getSimpleBankAccount: "bankAccount/getSimpleBankAccountAction",
      getSimpleUserList: "user/getSimpleUserListAction",
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    async loadReceive(page) {
      if (this.$route.query) {
        const id = this.$route.query.id;
        this.filterQuery.customer = id;
      }
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getReceive(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    async getRecive(page) {
      const id = this.$route.query.id;
      this.filterQuery.customer = id;
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
        // invalide: true,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getReceive(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadReceive();
    }, 1000),
    openEditReceive(e) {
      this.$refs.EditReceiveDrawer.openDrawer(e, "edit");
    },
    async choseCompany(company) {
      if (company) {
        this.filterQuery.company = company.value;
      } else {
        delete this.filterQuery.company;
      }
      await this.loadReceive();
    },
    async choseType(type) {
      if (type) {
        this.filterQuery.type = type.value;
      } else {
        delete this.filterQuery.type;
      }
      await this.loadReceive();
    },
    async choseStatus(status) {
      if (status) {
        this.filterQuery.status = status.value;
      } else {
        delete this.filterQuery.status;
      }
      await this.loadReceive();
    },
    async choseReceivedBy(receivedBy) {
      if (receivedBy) {
        this.filterQuery.receivedBy = receivedBy.value;
      } else {
        delete this.filterQuery.receivedBy;
      }
      await this.loadReceive();
    },
    async refreshMethod() {
      await this.loadReceive();
    },
    changeDate(e) {
      switch (e) {
        case "start":
          this.startMonthStr = dayjs(this.exportItem.startMonth)
            .startOf("month")
            .format("YYYY-MM-DD");
          break;
        case "end":
          this.endMonthStr = dayjs(this.exportItem.endMonth)
            .startOf("month")
            .format("YYYY-MM-DD");
          break;
      }
    },
    async changeIsInvalid(e) {
      if (e) {
        this.filterQuery.invalid = e;
        await this.loadReceive();
      } else {
        delete this.filterQuery.invalid;
        await this.loadReceive();
      }
    },
    async exportReceive(name) {
      if (this.exportItem.startMonth) {
        this.exportItem.startMonth = dayjs(this.exportItem.startMonth).format(
          "YYYY-MM"
        );
      }
      if (this.exportItem.endMonth) {
        this.exportItem.endMonth = dayjs(this.exportItem.endMonth).format(
          "YYYY-MM"
        );
      }
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.exportReceiveLoading = true;
          try {
            const res = await axios.get(`/export_receive_table`, {
              responseType: "blob",
              params: { ...this.exportItem },
            });
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `回款记录${dayjs().format("MM-DD-YYYY")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            this.$Message.success("导出成功!");
            this.exportReceiveLoading = false;
            this.exportReceiveModal = false;
          } catch (error) {
            this.$Message.error({
              content: `导出失败!${error}`,
              closable: true,
              duration: 0,
            });
          }
        } else {
          this.$Message.error(`导出失败`);
        }
      });
    },
    openExportReceiveModal() {
      this.exportItem = {};
      this.startMonthStr = null;
      this.endMonthStr = null;
      this.exportReceiveModal = true;
      this.exportItem.startMonth = dayjs(new Date()).format("YYYY-MM");
      this.exportItem.endMonth = dayjs(new Date())
        .add(1, "month")
        .format("YYYY-MM");
      this.startMonthStr = dayjs(new Date())
        .startOf("month")
        .format("YYYY-MM-DD");
      this.endMonthStr = dayjs(new Date())
        .add(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
    openEditReceiveDrawer() {
      this.$refs.EditReceiveDrawer.openDrawer();
    },
    exportReceiveModalClose(e) {
      if (!e) {
        this.exportReceiveLoading = false;
      }
    },
    async clickActionDropDown(name) {
      this.actionReceiveId = null;
      const actionCode = name.slice(0, 1);
      this.actionReceiveId = name.slice(2);
      const receive = await this.getReceiveById(this.actionReceiveId);
      this.invalid = receive.invalid;
      switch (actionCode) {
        case "D":
          this.delReceiveModel = true;
          break;
        case "I":
          this.invalidReceiveModel = true;
          break;
        default:
          break;
      }
    },
    async delReceive() {
      try {
        await this.deleteReceive(this.actionReceiveId);
        this.$Message.success("删除成功");
      } catch (error) {
        this.$Message.error("删除失败：" + error);
      }
    },
    async invalidReceiveMethod() {
      const data = {};
      data.invalid = !this.invalid;
      try {
        await this.invalidReceive({
          id: this.actionReceiveId,
          data,
        });
        this.$Message.success(`${data.invalid ? "作废" : "恢复"}成功`);
      } catch (error) {
        this.$Message.error(`${data.invalid ? "作废" : "恢复"}失败：` + error);
      }
    },
  },
  async created() {
    await this.getSimpleUserList({ limit: 99 });
    await this.getSimpleBankAccount({ limit: 99 });
    await this.getCompanyList({ limit: 99, skip: 0 });
    this.loadReceive();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .refresh
    cursor pointer

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.export-item
  margin-bottom 20px

.dateStr
  font-size 16px
  margin-left 2px
</style>